import API from '../../shared/Config/API';
import APIEndpoints from '../../shared/Config/APIEndpoints';
import { BUSINESS_VERTICAL, VENDOR_TYPES } from '../../shared/Constants/Constants';

const fetchServiceProviders = async () => {
  try {
    return await API.get(APIEndpoints.CENTRAL_ONBOARDING.VENDORS_MASTER, null, {
      vendorType: `${VENDOR_TYPES.SERVICE_PROVIDER},${VENDOR_TYPES.RECYCLER}`,
      businessVertical: BUSINESS_VERTICAL,
    });
  } catch (error) {
    console.error(error);
  }
};

const fetchSps = async () => {
  try {
    return await API.get(APIEndpoints.CENTRAL_ONBOARDING.VENDORS_MASTER, null, {
      businessVertical: BUSINESS_VERTICAL,
      vendorType: VENDOR_TYPES.SERVICE_PROVIDER,
    });
  } catch (error) {
    console.error(error);
  }
};

const fetchPwp = async () => {
  try {
    return await API.get(APIEndpoints.CENTRAL_ONBOARDING.VENDORS_MASTER, null, {
      businessVertical: BUSINESS_VERTICAL,
      vendorType: VENDOR_TYPES.RECYCLER,
    });
  } catch (error) {
    console.error(error);
  }
};

const getPaymentTerm = async (customerId) => {
  try {
    return await API.get(APIEndpoints.GET_PAYMENT_TERM, null, {
      customerId,
    });
  } catch (error) {
    console.error(error);
  }
};

export const serviceProviderAPI = {
  fetchServiceProviders,
  fetchSps,
  fetchPwp,
  getPaymentTerm,
};
